import { Component, OnInit, Injector, Input } from "@angular/core";
import { TableAbstractComponent } from "../../../../common-page-components/classes/table-abstract-component";
import { ResultsAthleteFiltersService } from "../../services/results-athlete-filters.service";
import {
  AthleteResultsStore,
  IMatch
} from "../../../../common-page-components/stores/entities-store/athlete-results-store";
import { HttpClient } from "@angular/common/http";
import { IHeaderConfig } from "src/app/common-page-components/headers-component/headers-component.component";
import { IAthleteBiography } from 'src/app/common-page-components/stores/entities-store/athlete-biography-store';
import { animationsTable } from '../../../../common-page-components/wa-table/wa-table.component';
import { PhaseStore } from '../../../../common-page-components/stores/entities-store/phase-store';

@Component({
  selector: "app-athlete-team-results",
  templateUrl: "./athlete-team-results.component.html",
  styleUrls: ["./athlete-team-results.component.scss"],
  animations: animationsTable
})
export class AthleteTeamResultsComponent extends TableAbstractComponent
  implements OnInit {
  /**
   * The headers of this table
   *
   * @type {Array<IHeaderConfig>}
   * @memberof BootstraAthleteMatchesComponent
   */
  headers: Array<IHeaderConfig> = [
    { name: "" }, // Self match photo team column
    { name: "" }, // Self match team name column
    { name: "" }, // Another match photo team  column
    { name: "" }, // Another match team name column
    {name:''}, // Column for the stage information.
    {name: ""}, // WIn match column
    { name: "Matches" } // Expand details column
  ];
  /**
   * Matches of the athlete for individual component
   *
   * @type {Array<IMatch>}
   * @memberof AthleteIndividualResultsComponent
   */
  @Input() matches: Array<IMatch>;

  /**
   * Array of members that belongs to the team
   *
   * @type {Array<IAthleteBiography>}
   * @memberof AthleteTeamResultsComponent
   */
  @Input() members:Array<IAthleteBiography>;
  innerTableIndex: number;
  constructor(
    injector: Injector,
    public results_service: ResultsAthleteFiltersService,
    http: HttpClient
  ) {
    super(injector, results_service, new PhaseStore(http));
    this.model.requestData({RBP:'ALL'}, true).subscribe();
  }

  ngOnInit() {}
    /**
   * A getter for get the athlete from common service
   *
   * @returns {IAthleteBiography}
   * @memberof BoostrapAthleteResultsComponent
   */
  get getSelfAthlete():IAthleteBiography{
    return this.results_service.common_service.athleteDetailStore.data[0];
  }

  clickOnTeam(index:number){
    if(index === this.innerTableIndex){
      this.innerTableIndex = undefined;
      return;
    }
    this.innerTableIndex = index;
  }

  isTeamSelected(index:number, indexOfRow:number){
    return this.innerTableIndex === index && this.isIndexSelected(indexOfRow);
  }
}
